import { toast } from 'react-toastify';
import { ErrorMessage } from '../components/errorMessage/ErrorMessage';
import { translationKeys } from '../core/translation/translation';
import { gamePadService } from './helperServices/GamePadService';
import { autoSpinHelper } from './helperServices/AutoSpinService';

export const ERROR_TYPES = {
  INVALID_TOKEN: 'INVALID_TOKEN',
  INVALID_SPIN: 'INVALID_SPIN',
  MONEY_TRANSACTION_ERROR: 'MONEY_TRANSACTION_ERROR',
  NOT_ENOUGH_MONEY: 'NOT_ENOUGH_MONEY',
  INVALID_OPERATION: 'INVALID_OPERATION',
  SPIN_NOTFOUND: 'SPIN_NOTFOUND',
  INVALID_SPIN_COUNT: 'INVALID_SPIN_COUNT',
  INVALID_AMOUNT: 'INVALID_AMOUNT',
};

class ErrorHandler {
  constructor() {
    this._registeredHandlers = {};
  }

  handle(error) {
    if (this._registeredHandlers[error?.errorMessage]) {
      return this._registeredHandlers[error?.errorMessage](error);
    } else {
      toast.error('Request Error');
    }
  }

  register(errorType, handler) {
    this._registeredHandlers[ERROR_TYPES[errorType]] = handler;
  }

  notEnoughMoney() {
    if (gamePadService.autoSpinActiveState) {
      autoSpinHelper.end();
      gamePadService.enableAll();
    }
    toast.error(<ErrorMessage message={translationKeys.NOT_ENOUGH_MONEY}/>);
  }
}

const stopAutoSpin = () => {
  if (gamePadService.autoSpinActiveState) {
    autoSpinHelper.end();
    gamePadService.enableAll();
  }
}

const errorHandler = new ErrorHandler(ERROR_TYPES);

errorHandler.register(ERROR_TYPES.INVALID_AMOUNT, () => {
  toast.error(<ErrorMessage message={translationKeys.INVALID_AMOUNT}/>);
  stopAutoSpin();
});
errorHandler.register(ERROR_TYPES.INVALID_SPIN, () => {
  toast.error(<ErrorMessage message={translationKeys.INVALID_SPIN}/>);
  stopAutoSpin();
});
errorHandler.register(ERROR_TYPES.MONEY_TRANSACTION_ERROR, () => {
  toast.error(<ErrorMessage message={translationKeys.MONEY_TRANSACTION_ERROR}/>);
  stopAutoSpin();
});
errorHandler.register(ERROR_TYPES.SPIN_NOTFOUND, () => {
  toast.error(<ErrorMessage message={translationKeys.SPIN_NOTFOUND}/>);
  stopAutoSpin();
});
errorHandler.register(ERROR_TYPES.INVALID_SPIN_COUNT, () => {
  toast.error(<ErrorMessage message={translationKeys.INVALID_SPIN_COUNT}/>);
  stopAutoSpin();
});
errorHandler.register(ERROR_TYPES.INVALID_OPERATION, () => {
  toast.error(<ErrorMessage message={translationKeys.INVALID_OPERATION}/>);
  stopAutoSpin();
});

export {
  errorHandler,
};
